import React, { ReactNode, ErrorInfo } from "react";

interface ChunkErrorBoundaryProps {
  children: ReactNode;
}

interface ChunkErrorBoundaryState {
  hasError: boolean;
}
class ChunkErrorBoundary extends React.Component<
  ChunkErrorBoundaryProps,
  ChunkErrorBoundaryState
> {
  constructor(props: ChunkErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (error.name === "ChunkLoadError") {
      const refreshed = sessionStorage.getItem("chunk-error-refreshed");

      if (!refreshed) {
        sessionStorage.setItem("chunk-error-refreshed", "true");
        window.location.reload();
      }
    }
  }

  render() {
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
